import type { CommonSlice } from '../bs/common'

/**
 * Serbian overrides for the shared strings.
 *
 * *provjerite* → *proverite*, *zahtjeva* → *zahteva*, *izmijeni* → *izmeni*,
 * *prije* → *pre*. The rest of this slice has no jat in it and is shared word
 * for word.
 */
export const common: Partial<CommonSlice> = {
  'time.minutesAgo': 'pre {count} min',
  'time.hoursAgo': 'pre {count} h',
  'time.daysAgo.one': 'pre {count} dan',
  'time.daysAgo.few': 'pre {count} dana',
  'time.daysAgo.many': 'pre {count} dana',
  'error.offline': 'Nema veze sa serverom. Proverite internet konekciju.',
  'error.tooManyRequests': 'Previše zahteva. Sačekajte trenutak.',
  'error.boundary.title': 'Ova stranica nije mogla da se prikaže',
  'error.boundary.body':
    'Greška je zabeležena. Ostatak aplikacije i dalje radi — možete da se vratite i nastavite.',
  'error.staleBuild.body':
    'Ova kartica je otvorena od ranije, pa deo aplikacije više nije dostupan. Osvežite stranicu — ništa nije izgubljeno.',
  'error.staleBuild.reload': 'Osveži stranicu',

  'action.edit': 'Izmeni',

  // *Osvježite* → *Osvežite*. The rest of the sentence has no jat in it.
  'update.consequence':
    'Osvežite kada završite ono što radite — nesačuvani unosi na ovom ekranu se gube, a prijave u redu čekanja ostaju.',
}
